module.exports = __webpack_public_path__ + "static/media/briskfashion.a509a70e.mp3";